
import log from 'salvo-lite/log'
import currency from 'currency.js'

class UpdateTotal {
    constructor (theme, elem) {
        this._elem = elem
        this._elems = {
            'select': document.querySelector('.product__price .price__current'),
            'relatedSelects': document.querySelectorAll('.related-products-item'),
            'input': document.querySelector('#qty'),
            'total': document.querySelector('.total-price-money .money'),
            'qtyminus': document.querySelector('.qtyminus'),
            'qtyplus': document.querySelector('.qtyplus')
        }
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)
        this._bindUIActions()
        this._updateTotalPrice()
    }

    _bindUIActions () {
        // update price after currency is updated on page load
        document.addEventListener('onCurrencyInit', e => {
            this._updateTotalPrice()
        })

        // update total when the currency is changed
        document.addEventListener('onCurrencyChange', e => {
            this._updateTotalPrice()
        })

        // update total when the quantity is entered
        this._elems.input.addEventListener('input', e => {
            this._updateTotalPrice()
        })

        // update total when the variant is changed
        document.addEventListener('onVariantChange', e => {
            this._elems.total.textContent = this._elems.select.querySelector('.money').textContent
            this._elems.total.dataset.currencyGbp = this._elems.select.querySelector('.money').dataset.currencyGbp
            this._updateTotalPrice()
        })

        // update total when related products are selected
        document.addEventListener('onRelatedItemSelected', e => {
            this._updateTotalPrice()
        })
        document.addEventListener('onRelatedItemDeselected', e => {
            this._updateTotalPrice()
        })

        // update total when "select all [related products]" button clicked
        document.addEventListener('onAllRelatedItemsSelected', e => {
            this._updateTotalPrice()
        })
        document.addEventListener('onAllRelatedItemsDeselected', e => {
            this._updateTotalPrice()
        })

        // change input quantity on click
        this._elems.qtyminus.addEventListener('click', e => {
            this._changeQuantity('minus')
        })
        this._elems.qtyplus.addEventListener('click', e => {
            this._changeQuantity('plus')
        })
    }

    _changeQuantity (direction) {
        let input = this._elems.input
        if (direction === 'minus' && input.value > 1) {
            input.value--
            this._updateTotalPrice()
        } else if (direction === 'plus') {
            input.value++
            this._updateTotalPrice()
        }
    }

    _updateTotalPrice () {
        let mainSelect = this._elems.select
        let relatedSelects = this._elems.relatedSelects
        let mainInput = this._elems.input
        let moneySpan = mainSelect.querySelector('.money')
        let mainPrice = moneySpan.textContent
        let currencyPrefix = mainPrice.match(/.+?(?=[0-9])/) ? mainPrice.match(/.+?(?=[0-9])/) : ''
        let currencySuffix = mainPrice.match(/\D+$/g) ? mainPrice.match(/\D+$/g) : ''
        let currencyJsPrice = currency(mainPrice)
        let numeralQty = currency(mainInput.value)
        let mainTotal = currencyJsPrice.value * numeralQty.value
        let relatedTotal = 0

        for (let relatedSelect of relatedSelects) {
            let relatedPrice = currency(relatedSelect.querySelector('.money').textContent)
            if (relatedSelect.classList.contains('checked')) {
                let number = relatedTotal + relatedPrice.value
                relatedTotal = number
            }
        }

        let total = (mainTotal + relatedTotal).toFixed(2)
        let currencyTotal = currency(total)
        this._elems.total.textContent = currencyPrefix + currencyTotal.format() + currencySuffix
    }
}

export default UpdateTotal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/UpdateTotal.js